import React from 'react';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import textMaskEmailMask from 'text-mask-addons/dist/emailMask';
import Input from '../Input';
import MaskedInputWithShowMaskOnFocus from './components/MaskedInputWithShowMaskOnFocus';

export const integerMask = createNumberMask({
  prefix: '',
  allowDecimal: false,
  includeThousandsSeparator: false,
});
export const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: false,
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
});
export const currencyMask = createNumberMask({ prefix: '', integerLimit: 13, allowDecimal: true });

export const currencyMaskWithSymbol = createNumberMask({
  prefix: '$',
  integerLimit: 13,
  allowDecimal: true,
});

export const currencyMaskWithSymbolAndNegativeValues = createNumberMask({
  prefix: '$',
  integerLimit: 13,
  allowDecimal: true,
  allowNegative: true,
});
export const percentageMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
});
export const percentageMaskWithSymbol = createNumberMask({
  prefix: '',
  suffix: '%',
  allowDecimal: true,
  decimalLimit: 3,
});
export const ageMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  integerLimit: 3,
});
export const usPhoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const usZipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
export const ssnMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const emailMask = textMaskEmailMask;

export const DATE_FORMAT = 'MM-DD-YYYY';

// New masks
export const DATE_MASK = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

const MaskedInput = props => (
  <MaskedInputWithShowMaskOnFocus
    {...props}
    render={(ref, innerProps) => <Input ref={ref} {...innerProps} />}
  />
);

MaskedInput.Currency = props => (
  <MaskedInput {...props} mask={currencyMask} prependIcon={props.showIcon && 'fa fa-dollar-sign'} />
);

MaskedInput.Currency.defaultProps = {
  showIcon: false,
};

MaskedInput.Currency.propTypes = {
  showIcon: PropTypes.bool,
};

MaskedInput.CurrencyWithSymbol = props => (
  <MaskedInput
    {...props}
    pattern="\d*"
    onChange={ev =>
      props.onChange({ ...ev, target: { ...ev.target, value: ev.target.value.replace('$', '') } })
    }
    mask={props.allowNegative ? currencyMaskWithSymbolAndNegativeValues : currencyMaskWithSymbol}
  />
);

MaskedInput.CurrencyWithSymbol.defaultProps = {
  onChange: () => {
    // noop
  },
};

MaskedInput.CurrencyWithSymbol.propTypes = {
  onChange: PropTypes.func,
};

MaskedInput.PercentageWithSymbol = props => (
  <MaskedInput
    {...props}
    pattern="\d*"
    onChange={ev =>
      props.onChange({ ...ev, target: { ...ev.target, value: ev.target.value.replace('%', '') } })
    }
    mask={percentageMaskWithSymbol}
  />
);

MaskedInput.PercentageWithSymbol.defaultProps = {
  onChange: () => {},
};

MaskedInput.PercentageWithSymbol.propTypes = {
  onChange: PropTypes.func,
};

MaskedInput.Percentage = props => (
  <MaskedInput
    {...props}
    mask={percentageMask}
    // pattern="\d*"
    appendIcon={props.showIcon && 'fa fa-percent'}
  />
);

MaskedInput.Percentage.defaultProps = {
  id: undefined,
  label: undefined,
  showIcon: false,
};

MaskedInput.Percentage.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  showIcon: PropTypes.bool,
};

MaskedInput.UsPhoneNumber = props => <MaskedInput {...props} mask={usPhoneNumberMask} />;

MaskedInput.UsZipCode = props => <MaskedInput {...props} mask={usZipCodeMask} />;

MaskedInput.Email = props => <MaskedInput {...props} mask={emailMask} />;

MaskedInput.Age = props => <MaskedInput {...props} pattern="\d*" mask={ageMask} />;

export default MaskedInput;
